
import { connectArPorts } from "../ar-host.js";

export function connect(app, testHooks) {
    connectArPorts(app, ({ testHooks: testHooks }));
}

//# sourceMappingURL=ArInterop.js.map
